// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"ac2dac90","897":"07c96347"}[chunkId] + ".chunk.js";
};